import Auth from './Modules/Auth'
import Product from './Modules/Product'
import User from './Modules/User'

const auth = Auth.build()
const product = Product.build()
const user = User.build()

export { auth, product, user }
